module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://assets-platform.loblaws.ca/ldp-core-web-prod/production/ldp/view-resolver-sdm/latest/dist/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["ldpViewResolverSdm"]) {
      return window.remoteLoading["ldpViewResolverSdm"].then(resolve).catch(reject);
    }

    var res, rej;
    window.remoteLoading["ldpViewResolverSdm"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["ldpViewResolverSdm"] !== 'undefined') {
      res();
      return resolve();
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["ldpViewResolverSdm"] !== 'undefined') {
          res();
          return resolve();
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "ldpViewResolverSdm"
    );
  }).then(function () {
    const proxy = {
      get: ldpViewResolverSdm.get,
      init: function(shareScope) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          ldpViewResolverSdm.init(new Proxy(shareScope, handler))
        } catch (e) {

        }
        ldpViewResolverSdm.__initialized = true
      }
    }
    if (!ldpViewResolverSdm.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });